import * as React from 'react';
import { NewbuildingCarousel, TDirection, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { isDeepEqual } from '@cian/newbuilding-utils';
import { Image } from '@cian/ui-kit/image';
import { IEcology, IEcologyImage } from '../../types/newbuilding/ecology';
import * as style from './EcologyCarousel.css';

import { ArrowControls } from './parts/ArrowControls';
import { SlideInfo } from './parts/SlideInfo';
import { trackParkSlideChange } from './tracking';
import { firstPaintOptions, mediaSettings } from './utils/carouselSettings';

export interface IEcologyCarouselProps {
  ecology: IEcology;
}

export interface IEcologyCarouselState {
  slides: React.ReactNode[] | null;
  currentSlide: number;
  trackedTabs: string[];
}

export class EcologyCarousel extends React.Component<IEcologyCarouselProps, IEcologyCarouselState> {
  public constructor(props: IEcologyCarouselProps) {
    super(props);

    const { ecology } = this.props;

    this.state = {
      slides: ecology.images && this.prepareSlides(ecology.images),
      currentSlide: 1,
      trackedTabs: [],
    };
  }

  public componentDidMount() {
    const { ecology } = this.props;

    this.setState({
      slides: ecology.images && this.prepareSlides(ecology.images),
    });
  }

  public componentDidUpdate(prevProps: IEcologyCarouselProps) {
    const { ecology } = this.props;

    if (
      prevProps.ecology.images.length !== ecology.images.length ||
      !isDeepEqual(prevProps.ecology.images, ecology.images)
    ) {
      this.setState({
        slides: this.prepareSlides(ecology.images),
        currentSlide: 1,
      });
    }
  }

  public prepareSlides = (mediaData: IEcologyImage[]): React.ReactNode[] => {
    return mediaData.map(media => <Image key={media.url} src={media.url} objectFit={'cover'} />);
  };

  public render() {
    const { slides, currentSlide } = this.state;
    const { ecology } = this.props;

    if (!slides || !slides.length) {
      return null;
    }

    return (
      <div className={style['carousel']}>
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={slides}
          defaultCurrentSlide={currentSlide}
          onSlideChange={this.onSlideChange}
        />
        {slides.length > 1 && (
          <ArrowControls
            disableLeft={currentSlide === 1}
            disableRight={currentSlide === slides.length}
            clickHandler={this.changeSlide}
          />
        )}
        <SlideInfo ecology={ecology} />
      </div>
    );
  }

  private onSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    const { trackedTabs } = this.state;
    const {
      ecology: { title },
    } = this.props;

    if (!trackedTabs.includes(title)) {
      trackParkSlideChange(title);

      this.setState({
        trackedTabs: [...trackedTabs, title],
      });
    }

    this.setState({
      currentSlide,
    });
  };

  private changeSlide = (direction: TDirection) => {
    this.setState({
      currentSlide: this.state.currentSlide + direction * 1,
    });
  };
}
